import wxBridge from '../jsbridge/jsbridge_base.js';
// 参数示例：
// param = {
//     "key"        : "my_key",    // 必填
//     "value"      : "my_value",  // 必填
//     "weight"     : 1,           // 非必填，权重按字典顺序，但此处只允许1-9，默认用1，
//     "expireTime" : "3600",      // 非必填，过期时长，默认7天，单位秒
//     "autoClean"  : true         // 非必填，默认true, 若为false则不执行自动清除策略，若空间已满，则返回fail_exceed_size
// };

wxBridge.setGameData = wxBridge.setGameData  || function(param, callback) {    
    if(param.expireTime){
        param.expireTime += ""; // 安卓有bug，只有string类型才有效
    }
    wxBridge.invoke('setGameData', param, callback);
};

export default wxBridge;

export const {
    setGameData
} = wxBridge;
